import { MessageContext, MessageType } from "../contexts/MessageContext";
import { waitForMessageClose } from "../services/messageService";
import { useContext } from "react";

export const useShowMessage = () => {
  const { dispatch } = useContext(MessageContext);

  const showMessage = async (content: string, type: MessageType = MessageType.Info) => {
    dispatch({ type: "SET_MESSAGE", payload: { content, type } });
    await waitForMessageClose();
  };

  return showMessage;
};
